import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React from 'react';
import { Card } from 'react-bootstrap';

const ADSelectedAppeals = () => {
  const data = [
    {
      id: 1,
      amount: '$150',
      items: ['Zakat', 'Somalia', 'Water Relief Project']
    },
    { id: 2, amount: '$150', items: ['Zakat', 'Somalia', 'Food Project'] },
    {
      id: 3,
      amount: '$150',
      items: ['Zakat', 'Somalia', 'Water Relief Project']
    }
  ];

  return (
    <Card className="mb-3">
      <Card.Header className="pb-0">
        <Card.Title className="fw-medium">Selected Appeals</Card.Title>
      </Card.Header>
      <Card.Body>
        {data?.map(item => (
          <Flex
            key={item.id}
            justifyContent={'between'}
            className="border rounded-3 p-3 mb-3"
          >
            <div>
              <p className="mb-1 fs-0 fw-medium">
                {item.items?.map((type, index) => (
                  <span key={index}>
                    {type} {index != item.items.length - 1 && '| '}
                  </span>
                ))}
              </p>
              <p className="mb-0 fw-medium">
                Donation Amount : <span className="text-primary">$150.00</span>
              </p>
            </div>
            <Flex>
              <IconButton
                icon={'pen'}
                iconClassName="me-1"
                variant="link"
                className="p-0"
                onClick={() => console.log('Edit ' + item.id)}
              >
                <span className="d-none d-md-inline-block">Edit</span>
              </IconButton>
              <IconButton
                icon={'trash'}
                iconClassName="text-danger"
                variant="link"
                className="p-0 ms-3"
                onClick={() => console.log('Delete ' + item.id)}
              />
            </Flex>
          </Flex>
        ))}
        <hr />
        <Flex justifyContent={'between'}>
          <div>
            <p className="fw-medium mb-2">Transaction Fees</p>
            <p className="fs-0 mb-0 text-1000 fw-semi-bold">Total amount</p>
          </div>
          <div>
            <p className="fw-medium mb-2 text-end">20.00 USD</p>
            <p className="fs-0 mb-0 text-1000 fw-semi-bold text-end">
              1,050 USD
            </p>
          </div>
        </Flex>
      </Card.Body>
    </Card>
  );
};

export default ADSelectedAppeals;
